import script from "./Survey.vue?vue&type=script&setup=true&lang=js"
export * from "./Survey.vue?vue&type=script&setup=true&lang=js"

import "./Survey.vue?vue&type=style&index=0&id=329bd1a0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-329bd1a0"]])

export default __exports__